// modals/ConfirmAction.jsx
import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  Modal,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { Close } from "@mui/icons-material";
import { muiModalStyles } from "./styles";
import useScreenDimensions from "../hooks/useScreenDimensions";

export default function ConfirmAction({
  title,
  bodyText,
  submitButtonText = "Confirm",
  submitButtonColor = "primary",
  handleSubmit,
  onClose,
  open,
}) {
  const { windowWidth } = useScreenDimensions();
  const [loading, setLoading] = useState(false);

  const handleSubmitClick = async () => {
    setLoading(true);
    try {
      await handleSubmit?.();
    } catch (err) {
      console.error(err);
      // stay open on error so user can retry / cancel
      return;
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    if (loading) return;
    onClose?.();
  };

  return (
    <Modal open={open} onClose={handleCancel}>
      <Box
        sx={{
          ...muiModalStyles,
          width: windowWidth > 550 ? 550 : windowWidth - 50,
        }}
      >
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            {title}
          </Typography>
          <IconButton onClick={handleCancel} disabled={loading}>
            <Close />
          </IconButton>
        </Box>

        <Typography sx={{ my: 2 }} variant="body2">
          {bodyText}
        </Typography>

        <Box sx={{ display: "flex", flexDirection: "row", mt: 2 }}>
          <Button
            variant="contained"
            color={submitButtonColor}
            sx={{ mr: 1.5 }}
            onClick={handleSubmitClick}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              submitButtonText
            )}
          </Button>
          <Button variant="outlined" onClick={handleCancel} disabled={loading}>
            Cancel
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
